import React, { memo } from 'react';
import { connect } from 'react-redux';
import { Text, Switch } from 'hoi-poi-ui';
import { ACTIVITIES } from 'constants/Entities';
import { getLiteral } from 'utils/getLiteral';

import './styles.scss';

const mapStateToProps = (state) => {
    return {
        isSuspiciousCheckIn:
            state?.entityFilters?.[ACTIVITIES.entity]?.filters?.isSuspiciousCheckIn?.value || false,
    };
};

const MaxDistanceFilter = memo(({ isSuspiciousCheckIn }) => {
    return (
        <div className="activities-max-distance-filter">
            <Text>{getLiteral('label_suspicious_checkin')}</Text>
            <Switch checked={isSuspiciousCheckIn} />
        </div>
    );
});

export default connect(mapStateToProps)(MaxDistanceFilter);
